// src/pages/Teto_vs_egen/Main.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FaceAnimation from './Main/FaceAnimation.jsx';
import ChatAnalysis from './ChatAnalysis.jsx';
import './Main/Main.css';
import { trackEvent } from '../../utils/analytics';

function Main() {
  const navigate = useNavigate();
  const handleStart = () => {
    trackEvent('feature_selected', {
      feature_name: 'face_analysis',
      feature_type: 'face',
      source_page: 'face_intro',
    });
    navigate('/info');
  };

  return (
    <div className="main-wrapper">
      <h1 className="main-title">
        나의 얼굴로 시작하는 스타일 분석
      </h1>

      <div className="main-card">
        {/* 애니메이션 컴포넌트 삽입 */}
        <FaceAnimation />

        <h2 className="main-subtitle">TETO VS EGEN</h2>
        <p className="main-description">
          과학적인 지표로 나의 TETO/EGEN 지표를 시각화합니다.
        </p>
        <button
          onClick={handleStart}
          className="main-button"
        >
          분석 시작
        </button>
      </div>

      {/* Chat Analysis Section */}
      <ChatAnalysis />
    </div>
  );
}

export default Main;
